export default "/assets/images/lamp.f28895e0fa3fe7b5.png";